let load = require('./helpers/browser/esm-js-loader-shards')(4);
module.exports = (load("kx9Rt")).then(() => parcelRequire('dgNyv'));